import { Link } from "react-router-dom";

import {
  useIsAuthenticated,
  USER_ROLES,
  userHasRequiredRoles,
  useUserInfoQuery,
} from "@/features/shared/features/authentication";
import { useAdminPath } from "@/features/shared/navigation";

import NavigationItem from "./navigation-item";
import styles from "./navigation.module.css";

export default function NavigationSettings() {
  const isAuthenticated = useIsAuthenticated();
  if (!isAuthenticated) return null;

  return <NavigationSettingsInner />;
}

const NavigationSettingsInner = () => {
  const userInfoQuery = useUserInfoQuery();
  const isDashboardManager = userHasRequiredRoles(userInfoQuery.data?.roles || [], [
    USER_ROLES.admin,
  ]);
  const adminPath = useAdminPath();

  if (!isDashboardManager) return null;

  return (
    <Link to={adminPath} tabIndex={0} className={styles.navigationButton}>
      <NavigationItem icon="settings">Admin</NavigationItem>
    </Link>
  );
};
